import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom-v5-compat';

import { FilterSetName } from 'store/modules/routerUtils/types';
import { EnterpriseStatus } from 'types/models/enterprise';

const useApplyDefaultSearchParams = () => {
  const [isSearchParamsReady, setIsSearchParamsReady] = useState(false);
  const [, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (isSearchParamsReady) {
      return;
    }

    setSearchParams((oldSearchParams) => {
      const name = `filter.${FilterSetName.BACK_OFFICE_ENTERPRISES}.status[]`;
      if (oldSearchParams.has(name)) {
        setIsSearchParamsReady(true);
        return oldSearchParams;
      }

      const newSearchParams = new URLSearchParams(oldSearchParams);
      newSearchParams.append(name, EnterpriseStatus.ACTIVE);
      newSearchParams.append(name, EnterpriseStatus.DEMO);
      newSearchParams.append(name, EnterpriseStatus.PAST_DUE);
      newSearchParams.append(name, EnterpriseStatus.TEST);
      newSearchParams.append(name, EnterpriseStatus.TRIAL);
      newSearchParams.append(name, EnterpriseStatus.TRIAL_EXPIRED);
      setIsSearchParamsReady(true);

      return newSearchParams;
    });
  }, [isSearchParamsReady, setIsSearchParamsReady, setSearchParams]);

  return { isSearchParamsReady };
};

export default useApplyDefaultSearchParams;
